import React from "react";

const experience = [
  {
    name: "Health misinformation research",
    organization: "UIUC Center for Health Informatics",
    type: "Research",
    period: "2025–26",
    role: "Developer, LLM system",
    description:
      "Worked on evidence retrieval, confidence-based abstention, and a Streamlit tool for reviewing short-form video classifications.",
    detail:
      "The tool supported 10 researchers across 3 teams. Pilot precision improved by approximately 12 percentage points with abstention. Because abstention changes the set of returned predictions, precision should be read alongside coverage. Retrieval used WHO, CDC, and PubMed sources.",
  },
  {
    name: "LLM-enhanced topic modeling",
    organization: "UIUC School of Information Sciences",
    type: "Research",
    period: "2025–26",
    role: "Research with Prof. Jiangping Chen",
    description:
      "Compared approaches to topic modeling for social-media misinformation, including BERTopic, LDA, and LLM-based methods.",
    detail:
      "My work included reviewing the literature and examining how LLMs can enter a topic-modeling workflow: as an end-to-end model, during iterative refinement, or through post-processing. The focus was on understanding the methodological differences and evaluating implementations.",
  },
  {
    name: "STAT 207",
    organization: "UIUC Department of Statistics",
    type: "Teaching",
    period: "2025–26",
    role: "Course Assistant",
    description:
      "Helped students work through statistical inference, regression, and Python during office hours and review sessions.",
    detail:
      "I evaluated coding assignments, supported exam preparation, and troubleshot pandas, NumPy, scikit-learn, and Python environment issues. This was a regular opportunity to explain statistical reasoning and help someone locate the source of an error.",
  },
  {
    name: "UIUC Course Recommender",
    organization: "Personal project",
    type: "Project",
    period: "2025",
    role: "Full-stack application",
    description:
      "Combined course catalog information, historic GPA distributions, and general-education tags in a course-discovery tool.",
    detail:
      "The project connects a Next.js frontend to a Python/FastAPI service and PostgreSQL. Its data pipeline brings course information into a common structure for filtering and recommendations.",
    href: "https://github.com/maxz101524/UIUC_Course_Recommender",
    link: "Project repository",
  },
  {
    name: "Weather and emergency-department visits",
    organization: "UIUC Center for Health Informatics",
    type: "Research",
    period: "2025",
    role: "Predictive modeling",
    description:
      "Worked with ZIP-level weather and health data to model emergency-department visits associated with extreme weather.",
    detail:
      "I engineered temporal and spatial features, compared GAM and XGBoost models, and prepared a reproducible RMarkdown report. The work connected model evaluation with a public-health planning question.",
  },
  {
    name: "Midwest corn yield prediction",
    organization: "Illinois Data Science Club",
    type: "Team project",
    period: "2024",
    role: "Team lead",
    description:
      "Led a team combining USDA and NOAA data to predict corn yields.",
    detail:
      "The project included feature engineering, PCA, and comparisons of linear regression, support-vector regression, and XGBoost using hyperparameter search. It provided experience coordinating a shared modeling workflow.",
  },
];

export const ExperienceIndex: React.FC = () => (
  <section
    id="research"
    className="section shell"
    aria-labelledby="experience-title"
  >
    <div className="section-label">
      <h2 id="experience-title">Research, teaching &amp; side projects</h2>
      <p>Open an entry for a little more detail.</p>
    </div>
    <div className="experience-list">
      {experience.map((item) => (
        <details className="experience-entry" key={item.name}>
          <summary>
            <span className="experience-date">{item.period}</span>
            <span className="experience-name">
              <strong>{item.name}</strong>
              <span>
                {item.role} · {item.organization}
              </span>
            </span>
            <span className="experience-type">{item.type}</span>
            <span className="experience-toggle" aria-hidden="true" />
          </summary>
          <div className="experience-body">
            <p>{item.description}</p>
            <p>{item.detail}</p>
            {item.href && (
              <a
                className="text-link"
                href={item.href}
                target="_blank"
                rel="noreferrer"
              >
                {item.link}
              </a>
            )}
          </div>
        </details>
      ))}
    </div>
  </section>
);
